module.exports = __webpack_public_path__ + "static/media/karan.5c4f9465.jpg";